/* eslint-disable max-len */
/* jscs:disable maximumLineLength */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { isDatabaseBirthDate } from '../../core/util/time';
import { isDev } from '../../config/';

const monthNumber = 'M';
const monthAbbv = 'MMM';
const month = 'MMMM';
const dayNumber = 'D';
const dayAbbv = 'ddd';
const dayFull = 'dddd';
const dayOrd = 'Do';
const yearNumber = 'YYYY';
const hour = 'h';
const minute = 'mm';
const period = 'a';
const timeZone = 'z';

export const MONTH_DAY_YEAR = `${monthNumber}/${dayNumber}/${yearNumber}`;
export const MONTH_YEAR = `${month} ${yearNumber}`;
export const HOUR_MINUTE = `${hour}:${minute}`;
export const PERIOD_TIME_ZONE = `${period} ${timeZone}`;

export const DAY_ABBV_MONTH_DAY_YEAR = `${dayAbbv}, ${MONTH_DAY_YEAR}`;
export const HOUR_MINUTE_PERIOD = `${HOUR_MINUTE} ${period}`;

export const DAY_ABBV_HOUR_MINUTE_PERIOD = `${dayAbbv}, ${HOUR_MINUTE_PERIOD}`;

export const MONTH_DAY_YEAR_HOUR_MINUTE_PERIOD = `${MONTH_DAY_YEAR} ${HOUR_MINUTE} ${period}`;
export const MONTH_DAY_YEAR_HOUR_MINUTE_PERIOD_TIME_ZONE = `${MONTH_DAY_YEAR} ${HOUR_MINUTE} ${PERIOD_TIME_ZONE}`;

export const MONTH_NAME_DAY_YEAR = 'LL';

export const MONTH_ABBV_DAY = `${monthAbbv} ${dayNumber}`;
export const MONTH_ABBV_DAY_YEAR = `${monthAbbv} ${dayNumber}, ${yearNumber}`;
export const DAY_ABBV_MONTH_ABBV_DAY_YEAR = `${dayAbbv}, ${MONTH_ABBV_DAY_YEAR}`;
export const DAY_ABBV_MONTH_ABBV_DAY_TIME = `${dayAbbv}, ${MONTH_ABBV_DAY} \\at ${HOUR_MINUTE_PERIOD}`;
export const DAY_ABBV_MONTH_ABBV_DAY_YEAR_TIME = `${dayAbbv}, ${MONTH_ABBV_DAY_YEAR} \\at ${HOUR_MINUTE_PERIOD}`;
export const DAY_FULL_MONTH_DAY_NUMBER_YEAR = `${dayFull}, ${month} ${dayNumber}, ${yearNumber}`;
export const HOUR_MINUTE_PERIOD_DAY_MONTH_DAY_NUMBER = 'h:mm a  |  ddd, MMM D';

export const HOUR_MINUTE_PERIOD_TIME_ZONE = `${HOUR_MINUTE} ${PERIOD_TIME_ZONE}`;

export const APPOINTMENT_TIME_WITH_TIME_ZONE = MONTH_DAY_YEAR_HOUR_MINUTE_PERIOD_TIME_ZONE;
export const BIRTH_DATE = MONTH_ABBV_DAY_YEAR;
export const PERIOD = period;

export const MONTH_DAY_ORDINAL = `${month} ${dayOrd}`;
export const YEAR_MONTH_DAY_DASHED = `${yearNumber}-MM-DD`;
const DATABASE_BIRTH_DATE_FORMAT = YEAR_MONTH_DAY_DASHED;

const defaultOptions = { hideTimeZoneIfSame: true };

class DateTime extends PureComponent {
  static format = (dateTime, timeZoneIdentifier, options = defaultOptions) => format => {
    let newDateTime = null;

    if (isDatabaseBirthDate(dateTime)) {
      newDateTime = moment(dateTime, DATABASE_BIRTH_DATE_FORMAT);
    } else if (options.parseFormat) {
      newDateTime = timeZoneIdentifier
        ? moment.tz(dateTime, options.parseFormat, timeZoneIdentifier)
        : moment(dateTime, options.parseFormat);
    } else {
      newDateTime = timeZoneIdentifier ? moment.tz(dateTime, timeZoneIdentifier) : moment(dateTime);
    }

    if (!newDateTime.isValid()) {
      if (isDev()) {
        throw new Error('Moment did not like the dateTime provided to DateTime.format');
      } else {
        return null;
      }
    }

    return newDateTime.format(DateTime.getFormat(format, timeZoneIdentifier, options));
  };

  static getFormat = (format, timeZoneIdentifier, options) => {
    const userTimeZoneIdentifier = moment.tz.guess();

    if (options.hideTimeZoneIfSame && userTimeZoneIdentifier === timeZoneIdentifier) {
      return format.replace(` ${timeZone}`, '');
    }

    return format;
  };

  render = () => {
    const getFormattedDateTime = DateTime.format(
      this.props.dateTime,
      this.props.timeZone,
      this.props.options
    );

    return <div>{getFormattedDateTime(this.props.format)}</div>;
  };
}

DateTime.defaultProps = {
  format: MONTH_DAY_YEAR_HOUR_MINUTE_PERIOD,
  options: defaultOptions,
};

DateTime.propTypes = {
  dateTime: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]).isRequired,
  format: PropTypes.string,
  options: PropTypes.object,
  timeZone: PropTypes.string,
};

export default DateTime;
